import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getLocation } from 'services/geolocation';
import AuthRouter from './router';

import { AuthContainer, FormContainer, ImageContainer } from './styled';

const Auth = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const availableLanguages = i18n.options['languages'];
    const fallBackLanguage = i18n.options.fallbackLng[0];

    // Helper to map detected languages to supported ones
    const mapToSupportedLanguage = (detectedList) => {
      if (!Array.isArray(detectedList)) return fallBackLanguage;
      for (let lang of detectedList) {
        lang = lang.toLowerCase();
        if (lang.includes('de') || lang.includes('-ch')) return 'de';
        if (lang.startsWith('fr')) return 'fr';
        if (lang.startsWith('it')) return 'it';
        if (lang.startsWith('es')) return 'es';
        if (lang.startsWith('ru')) return 'ru';
        if (lang.startsWith('en')) return 'en';
        // Direct match to available languages
        if (availableLanguages.includes(lang)) return lang;
        // Try base language (e.g., 'de-CH' -> 'de')
        const baseLang = lang ? lang.split('-')[0] : '';
        if (availableLanguages.includes(baseLang)) return baseLang;
      }
      return fallBackLanguage;
    };

    getLocation()
      .then((result) => {
        const detectedLanguages = result.languages
          ? result.languages
              .split(',')
              .map((l) => l.trim())
              .slice(0, 4)
          : [];
        let langToSet = mapToSupportedLanguage(detectedLanguages);
        // If geolocation result is not useful, fallback to browser language
        if (!langToSet || langToSet === fallBackLanguage) {
          const browserLangs = navigator.languages || [navigator.language];
          langToSet = mapToSupportedLanguage(browserLangs);
        }
        i18n.changeLanguage(langToSet);
      })
      .catch(() => {
        // On geolocation error, fallback to browser language
        const browserLangs = navigator.languages || [navigator.language];
        const langToSet = mapToSupportedLanguage(browserLangs);
        i18n.changeLanguage(langToSet);
      });
  }, []);

  return (
    <AuthContainer>
      <FormContainer>
        <AuthRouter />
      </FormContainer>
      <ImageContainer />
    </AuthContainer>
  );
};

export default Auth;
